import React from 'react';

const NumberCircle = ({ number }) => (
  <div className="number-circle">
    <p className="body3">{number}</p>
  </div>
);

export default NumberCircle;
